import AddClass from "./AddClass";
import SortItemsFromQuery from "./SortItemsFromQuery";

export default class Solution {
  constructor() {
    new AddClass();
    new SortItemsFromQuery();
  }
}
